"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { observable, action, computed } from "mobx";
import { MenuItem } from "../../../pieces/MenuItem/MenuItem";
import * as styles from "./FolderComponent-css";
import { handleMouseUpByBlurring } from "../../../../utils";
export let FolderComponent = class extends React.Component {
  constructor(props) {
    super(props);
    this.dragHoverCounter = 0;
  }
  handleClick() {
    const { onClick, disableSelect } = this.props;
    if (disableSelect)
      return;
    onClick == null ? void 0 : onClick();
  }
  render() {
    const _a = this.props, { name, icon, selected, overrideNameComponent, disableSelect, disableDrop } = _a, props = __objRest(_a, ["name", "icon", "selected", "overrideNameComponent", "disableSelect", "disableDrop"]);
    const handleClick = this.handleClick.bind(this);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.container({ draggedOver: !disableDrop && this.isDragHovering }),
        onDrop: this.dropHandler,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDragOver: (event) => {
          event.preventDefault();
        }
      },
      /* @__PURE__ */ React.createElement(
        MenuItem,
        __spreadProps(__spreadValues({
          strong: true,
          truncate: true,
          startElement: icon,
          active: selected,
          disabled: disableSelect || disableDrop
        }, props), {
          onClick: handleClick,
          onMouseUp: handleMouseUpByBlurring
        }),
        !!overrideNameComponent ? overrideNameComponent : name
      )
    );
  }
  get isDragHovering() {
    return this.dragHoverCounter > 0;
  }
  onDragEnter(event) {
    event.preventDefault();
    ++this.dragHoverCounter;
  }
  onDragLeave(event) {
    event.preventDefault();
    --this.dragHoverCounter;
  }
  dropHandler(event) {
    event.preventDefault();
    this.dragHoverCounter = 0;
    const { onDrop, disableDrop } = this.props;
    if (!!onDrop && !disableDrop) {
      onDrop(event);
    }
  }
};
FolderComponent.defaultProps = {
  element: "button",
  hasMenuOption: false,
  disableSelect: false,
  disableDrop: false
};
__decorateClass([
  observable.ref
], FolderComponent.prototype, "dragHoverCounter", 2);
__decorateClass([
  computed
], FolderComponent.prototype, "isDragHovering", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "onDragEnter", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "onDragLeave", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "dropHandler", 1);
FolderComponent = __decorateClass([
  observer
], FolderComponent);
